import { createApiRef } from '@backstage/core-plugin-api';
import z from 'zod';

/**
 * ApiRef for the DeploymentManagementApi.
 *
 * @public
 */
export const deploymentManagementApiRef = createApiRef(
  {
    id: 'plugin.deployment-management.api',
  },
);












































































export const UpdateReleaseTagResponse = z.object({
  message: z.string(),
  code: z.number(),
});





export const ExecuteDeploymentPlanResponse = z.object({
  message: z.string(),
});





export const MostRecentReleaseResponse = z.object({
  releaseId: z.number(),
  releaseLabel: z.string(),
  dirty: z.boolean(),
});

export const ReleaseFlag = z.enum(['hotfix', 'blocked', 'stable', 'breaking']);


export const ServiceVersions = z.object({
  name: z.string(),
  version: z.string(),
});



export const ReleaseServiceVersions = z.object({
  releaseId: z.number(),
  releaseContains: z.array(ServiceVersions),
  currentServiceVersions: z.array(ServiceVersions),
  releaseLabel: z.string(),
  tag: z.string().optional(),
});



const ReleaseStatus = z.enum(['Ready', 'Pending']);

export const Release = z.object({
  releaseId: z.number(),
  releaseLabel: z.string(),
  releaseDescription: z.string(),
  releaseNotes: z.string(),
  flags: z.array(ReleaseFlag),
  releaseTimestamp: z.string(),
  status: ReleaseStatus,
  tag: z.string().optional(),
});



const ChangeType = z.enum(['add', 'remove', 'change']);

const Kind = z.enum(['configmap', 'secret', 'unknown']);

const ReleasedServiceContent = z.object({
  name: z.string(),
  version: z.string(),
  status: ReleaseStatus,
  envVarUpdates: z.array(
    z.object({
      serviceName: z.string(),
      name: z.string(),
      defaultValue: z.string(),
      changeType: ChangeType,
      kind: Kind,
    }),
  ),
});

const CurrentServiceContent = z.object({
  name: z.string(),
  version: z.string(),
  status: ReleaseStatus,
});

export const ReleaseContentResponse = z.object({
  releaseLabel: z.string(),
  releaseContains: z.array(ReleasedServiceContent),
  currentServiceVersions: z.array(CurrentServiceContent),
  status: ReleaseStatus,
  tag: z.string(),
});


export const Environment = z.object({
  environmentId: z.number(),
  customerName: z.string(),
  environmentName: z.string(),
  url: z.string(),
  gitopsDeploymentPath: z.string(),
});


export const EnvironmentRelease = z.object({
  releaseId: z.string(),
  releaseLabel: z.string(),
  // TODO: remove the .optional() when the API is ready to provide the data
  releaseNotes: z.string().optional(),
  releaseTimestamp: z.string().optional(),
  releaseDescription: z.string().optional(),
  flags: z.array(ReleaseFlag).optional(),
});



export const EnvVarKind = z.enum(['configmap', 'secret', 'unknown']);


export const EnvironmentVariableResponseItem = z.object({
  environmentVariableId: z.number(),
  serviceName: z.string(),
  variableName: z.string(),
  variableValue: z.string(),
  kind: EnvVarKind,
});





export const EnvironmentVariableRequestItem = z.object({
  serviceName: z.string(),
  variableName: z.string(),
  variableValue: z.string(),
  kind: EnvVarKind,
});





export const EnvironmentVariableRequestItems = z.array(
  EnvironmentVariableRequestItem,
);

export const EnvironmentService = z.object({
  customerServiceId: z.number(),
  customerId: z.number(),
  serviceName: z.string(),
  updatedAt: z.string(),
  deletedAt: z.string().optional(),
});



export const MasterService = z.object({
  serviceName: z.string(),
  isDeprecated: z.boolean(),
  updatedAt: z.string(),
  deletedAt: z.string(),
});







export const DeploymentPlanIdResponse = z.object({
  deploymentPlanId: z.number(),
});



export const DeploymentStatus = z.enum([
  'Successful',
  'InProgress',
  'Failed',
  'Pending',
]);



export const DeploymentPlan = z.object({
  createdAt: z.string(),
  customerName: z.string(),
  deployedAt: z.string(),
  dirty: z.boolean(),
  deploymentPlanId: z.number(),
  environmentId: z.string(),
  environmentName: z.string(),
  startedAt: z.string(),
  status: DeploymentStatus,
});



const DeploymentPlanServiceEntry = z.object({
  serviceName: z.string(),
  serviceVersion: z.string(),
  deployedAt: z.string(),
  deployScript: z.string().url({ message: 'Invalid url' }),
  rollbackScript: z.string().url({ message: 'Invalid url' }),
  previousServiceVersion: z.string(),
  serviceReleaseNotes: z.string().url({ message: 'Invalid url' }),
  status: DeploymentStatus,
});

const DeploymentPlanEnvVarUpdate = z.object({
  serviceName: z.string(),
  name: z.string(),
  value: z.string(),
  overrideValue: z.string(),
  changeType: ChangeType,
  kind: Kind,
});





const DeploymentPlanEntry = z.object({
  releaseLabel: z.string(),
  releaseId: z.number(),
  step: z.number(),
  deploy: z.boolean(),
  status: DeploymentStatus,
  jenkinsUrl: z.string().nullable(),
  servicesToDeploy: z.array(DeploymentPlanServiceEntry),
  allServices: z.array(DeploymentPlanServiceEntry),
  envVarUpdates: z.array(DeploymentPlanEnvVarUpdate).nullable(),
});



export const DeploymentPlanResponse = z.object({
  deploymentPlanId: z.number(),
  status: DeploymentStatus,
  deploymentPlan: z.array(DeploymentPlanEntry),
});
















